import React, { useState, useEffect } from 'react'
import { useAuth } from "./api/authStore"


const map = (type) => {
    switch(type){
        case 'BTC':
            return {currency: type, network: 'btc', }
        case 'LTC':
            return {currency: type, network: 'ltc', }
        case 'USDT':
            return {currency: type, network: 'tron',}
        case 'ETH':
            return {currency: type, network: 'arbitrum',}
        case 'XMR':
            return {currency: type, network: 'xmr'}
        default:
            return {currency: 'btc', network: 'btc'}
    }
}

const PaymentDialog = (props) => {


    const { user, getAccessTokenSilently, setToken, logout } = useAuth()

    const [error, setError] = React.useState(null)
    const [currency, setCurrency] = React.useState('')
    const [amount, setAmount] = React.useState(5)

    const handleClose = () => {
        props.setOpentPaymentDialog(false)
        setError(null)
    }


    const handleAdd = async() => {
        // Проверяем, что сумма больше 0
        if (amount <= 0) {
            setError('Amount must be greater than 0.')
            return
        }

        try {
            const response = await props.apiClient.setToken(getAccessTokenSilently()).chargeRequest(currency, amount)



            // Используем редирект вместо popup для избежания блокировки браузера
            window.location.href = response.url
            props.setOpentPaymentDialog(false)
        } catch (e) {
            // console.log(e)
            setError('Try again, please.')
        }
    }

    const handleSelectCurrency = (event) => {
        setCurrency(map(event.target.value))
    }

    const handleChangeAmount = (e) => {
        const value = e.target.value
        
        // Если поле пустое, устанавливаем 0
        if (value === "") {
            setAmount(0)
            return
        }
        
        const amount = parseFloat(value)
        
        // Проверяем, что это валидное число
        if (isNaN(amount)) {
            return // Не обновляем состояние для невалидных значений
        }
        
        // Предотвращаем ввод отрицательных значений
        if (amount < 0) {
            setAmount(0)
        } else {
            setAmount(amount)
        }
    }

    return (
        <>
            {/* Модальное окно платежа */}
            {props.open && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 10000
                }} onClick={handleClose}>
                    <div style={{
                        background: 'var(--medium-gray)',
                        border: '1px solid var(--light-gray)',
                        borderRadius: 'var(--radius-lg)',
                        padding: 'var(--spacing-2xl)',
                        maxWidth: '500px',
                        width: '90%',
                        boxShadow: 'var(--shadow-card)',
                        position: 'relative'
                    }} onClick={(e) => e.stopPropagation()}>
                        
                        {/* Кнопка закрытия */}
                        <button
                            onClick={handleClose}
                            style={{
                                position: 'absolute',
                                top: 'var(--spacing-md)',
                                right: 'var(--spacing-md)',
                                background: 'none',
                                border: 'none',
                                color: 'var(--text-muted)',
                                fontSize: 'var(--text-xl)',
                                cursor: 'pointer',
                                padding: '4px'
                            }}
                        >
                            ✕
                        </button>

                        {/* Заголовок */}
                        <h2 style={{
                            color: 'var(--text-light)',
                            fontSize: 'var(--text-2xl)',
                            fontWeight: '700',
                            marginBottom: 'var(--spacing-xl)',
                            textAlign: 'center',
                            background: 'var(--gradient-orange)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            backgroundClip: 'text'
                        }}>
                            Payment
                        </h2>


                        {/* Информация о криптовалютах */}
                        <div style={{
                            background: 'var(--dark-gray)',
                            border: '1px solid var(--light-gray)',
                            borderRadius: 'var(--radius-md)',
                            padding: 'var(--spacing-lg)',
                            marginBottom: 'var(--spacing-lg)'
                        }}>
                            <p style={{
                                color: 'var(--text-light)',
                                fontSize: 'var(--text-base)',
                                margin: '0 0 var(--spacing-sm) 0',
                                lineHeight: '1.5'
                            }}>
                                We accept only next crypto currencies:
                            </p>
                            <div style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: 'var(--spacing-sm)',
                                marginTop: 'var(--spacing-sm)'
                            }}>
                                {['BTC', 'LTC', 'USDT', 'TRX', 'ETH'].map((crypto) => (
                                    <span key={crypto} style={{
                                        background: 'var(--primary-orange)',
                                        color: 'var(--white)',
                                        padding: 'var(--spacing-xs) var(--spacing-sm)',
                                        borderRadius: 'var(--radius-sm)',
                                        fontSize: 'var(--text-sm)',
                                        fontWeight: '600'
                                    }}>
                                        {crypto}
                                    </span>
                                ))}
                            </div>
                        </div>

                        {/* Поле для суммы */}
                        <div style={{ marginBottom: 'var(--spacing-lg)' }}>
                            <label style={{
                                color: 'var(--text-light)',
                                fontSize: 'var(--text-sm)',
                                fontWeight: '600',
                                marginBottom: 'var(--spacing-sm)',
                                display: 'block'
                            }}>
                                Amount USD
                            </label>
                            <input
                                type="number"
                                min="0"
                                step="0.10"
                                value={amount}
                                onChange={handleChangeAmount}
                                placeholder="Enter amount"
                                style={{
                                    width: '100%',
                                    padding: 'var(--spacing-md)',
                                    background: 'var(--dark-gray)',
                                    border: '2px solid var(--light-gray)',
                                    borderRadius: 'var(--radius-md)',
                                    color: 'var(--text-light)',
                                    fontSize: 'var(--text-base)',
                                    outline: 'none',
                                    transition: 'var(--transition-normal)'
                                }}
                                onFocus={(e) => {
                                    e.target.style.borderColor = 'var(--primary-orange)'
                                    e.target.style.boxShadow = '0 0 0 3px rgba(255, 140, 0, 0.1)'
                                    // Выделяем весь текст для удобства замены
                                    e.target.select()
                                }}
                                onBlur={(e) => {
                                    e.target.style.borderColor = 'var(--light-gray)'
                                    e.target.style.boxShadow = 'none'
                                }}
                            />
                        </div>

                        {/* Ошибка */}
                        {error !== null && (
                            <div style={{
                                background: '#dc3545',
                                color: 'var(--white)',
                                padding: 'var(--spacing-md)',
                                borderRadius: 'var(--radius-md)',
                                marginBottom: 'var(--spacing-lg)',
                                textAlign: 'center',
                                fontSize: 'var(--text-sm)',
                                fontWeight: '500'
                            }}>
                                {error}
                            </div>
                        )}

                        {/* Предупреждение о возврате */}
                        <div style={{
                            background: 'var(--dark-gray)',
                            border: '1px solid var(--light-gray)',
                            borderRadius: 'var(--radius-md)',
                            padding: 'var(--spacing-md)',
                            marginBottom: 'var(--spacing-xl)',
                            textAlign: 'center'
                        }}>
                            <p style={{
                                color: 'var(--text-muted)',
                                fontSize: 'var(--text-sm)',
                                margin: '0',
                                lineHeight: '1.5'
                            }}>
                                Deposited funds are non-refundable and cannot be returned.
                            </p>
                        </div>

                        {/* Кнопки */}
                        <div style={{
                            display: 'flex',
                            gap: 'var(--spacing-md)',
                            justifyContent: 'center'
                        }}>
                            <button
                                onClick={handleClose}
                                className="btn btn-outline"
                                style={{ minWidth: '100px' }}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleAdd}
                                className="btn btn-primary"
                                style={{ minWidth: '120px' }}
                            >
                                Add Funds
                            </button>
                        </div>
                    </div>
                </div>
            )}
            
        </>
    )
}

export default PaymentDialog